import classnames from 'classnames'
import ArrowButton from '../ArrowButton/ArrowButton'

import styles from './PreviousArrow.module.scss'

interface PreviousArrowProps {
  className?: string
  onClick?: () => void
}

const PreviousArrow = ({ className, onClick }: PreviousArrowProps) => (
  <ArrowButton
    className={classnames(styles.slickPrev, className)}
    isLeftArrow
    onClick={onClick}
  />
)

export { PreviousArrow }
